




















import { Component, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { BlipAccount } from '@/models'
import defaultBotImage from '@/assets/images/avatar-default.png'
import Vue from 'vue'

@Component
export default class WelcomeScreen extends Vue {
  @Getter botAccountData: BlipAccount
  @Getter displayName: string
  @Getter botIdentity
  @Getter hidePowered

  @Prop({ type: Function, required: true })
  sendStartMessage: (arg) => void
  @Prop({ type: String, required: true })
  accountStatus: string
  @Prop({ type: String, required: true })
  botWelcomeMessage: string
  @Prop({ type: String, required: true })
  botStartButton: string
  @Prop({ type: String, required: true })
  botStartButtonLabel: string
  @Prop({ type: Boolean, required: true })
  showCloseButton: Boolean
  @Prop({ type: Function, required: true })
  closeChat: Function

  get botPhoto() {
    return this.botAccountData.photoUri || defaultBotImage
  }

  sendMessage() {
    this.sendStartMessage(this.botStartButton)
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/WelcomeScreen.vue